import { useState } from 'react'
import clsx from 'clsx'

import { ListItem, ListItemText, makeStyles, Avatar, Box } from '@material-ui/core'
import { TextOverflow } from '@guidde-co/shared.text-overflow.text-overflow'

import { ProfileDialog, SpacedGroup, useMenuStatus } from 'UI/Components'

import { useBoolean, useAuth } from 'hooks'
import { uiId } from 'modules'

const useStyles = makeStyles(theme => ({
    gutters: {
        padding: theme.spacing(0.5, 4, 0.5, 2)
    },
    avatarImg: {
        height: '30px',
        width: '30px',
        borderRadius: '50%'
    },
    name: {
        fontSize: '14px',
        letterSpacing: 0.1
    },
    userInfo: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '150px'
    },
    hidden: {
        opacity: 0,
        transition: 'opacity 0.1s linear'
    }
}))

export const MenuProfile = () => {
    const classes = useStyles()
    const showProfileDialog = useBoolean()
    const [profileRef, setProfileRef] = useState<HTMLElement | null>(null)

    const { displayName, email, photoURL } = useAuth()
    const { isMenuClosed } = useMenuStatus()

    return (
        <Box minHeight={70} display="flex" alignItems="center">
            <ListItem
                data-cy="menu-user"
                button
                key="a"
                id={uiId('menu-user')}
                classes={{
                    gutters: !isMenuClosed ? classes.gutters : ''
                }}
                onClick={showProfileDialog.toggle}
            >
                <SpacedGroup
                    spacing={1}
                    pl={0.5}
                    onClick={e => {
                        const target = e.currentTarget as HTMLElement
                        setProfileRef(target)
                    }}
                >
                    <Avatar
                        className={classes.avatarImg}
                        src={`${photoURL}&time=${performance.now()}`}
                    />
                    <TextOverflow>
                        <ListItemText
                            classes={{
                                primary: clsx(classes.name, classes.userInfo),
                                secondary: classes.userInfo
                            }}
                            className={clsx({ [classes.hidden]: isMenuClosed })}
                            primary={displayName || email}
                            secondary={displayName === email ? '' : email}
                        />
                    </TextOverflow>
                </SpacedGroup>
            </ListItem>
            <ProfileDialog
                isOpen={showProfileDialog.isTrue}
                anchorEl={profileRef}
                onClose={showProfileDialog.setFalse}
            />
        </Box>
    )
}
